import styled, { css } from 'styled-components';

export const LineBar = styled.div.withConfig({
  shouldForwardProp: (prop) => !['bgColor'].includes(prop),
})`
  position: relative;
  width: 100%;
  height: ${(props) => props.height}px;
  border-radius: 6px;
  background-color: ${(props) => props.bgColor};
`;

export const PercentageLine = styled.span.withConfig({
  shouldForwardProp: (prop) =>
    !['percentage', 'height', 'color'].includes(prop),
})`
  position: absolute;
  top: 0;
  left: 0;
  width: ${(props) => (props.percentage > 0 ? `${props.percentage}%` : 0)};
  height: ${(props) => props.height}px;
  border-radius: 6px;
  background-color: ${(props) => props.color};
`;

export const Percentage = styled.span`
  font-size: 12px;
  font-weight: normal;
  color: ${(props) => props.theme.colors.greyLighter};
  padding-left: 5px;
`;

export const Container = styled.div.withConfig({
  shouldForwardProp: (prop) => !['mb', 'rearrange'].includes(prop),
})`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: ${({ mb }) => `${mb}px`};

  ${({ rearrange }) =>
    rearrange &&
    css`
      flex-direction: column-reverse;
      align-items: flex-start;
      position: relative;

      .percentage {
        position: absolute;
        top: -24px;
        left: 0;
        color: ${({ theme }) => theme.colors.textPrimary};
        font-size: 14px;
        padding: 0 0 2px 0;
      }
    `}
`;
